import { useNavigate } from "react-router-dom";
import Avatar from "./Avatar";
import { ChevronRight } from "lucide-react";

interface Activity {
  id: string;
  clientId: string;
  name: string;
  action: string;
  detail?: string;
  time: string;
  avatarColor: string;
  type: "consent" | "treatment" | "booking" | "payment" | "new_client";
}

const activities: Activity[] = [
  {
    id: "1",
    clientId: "c1",
    name: "Sarah Miller",
    action: "signed consent form for",
    detail: "Hydrafacial Treatment",
    time: "5 mins ago",
    avatarColor: "purple",
    type: "consent",
  },
  {
    id: "2",
    clientId: "c2",
    name: "Emma Clark",
    action: "completed",
    detail: "PRP Facial Rejuvenation",
    time: "25 mins ago",
    avatarColor: "pink",
    type: "treatment",
  },
  {
    id: "3",
    clientId: "c3",
    name: "Rachel Adams",
    action: "booked appointment for",
    detail: "Dermal Fillers - Lips",
    time: "1 hour ago",
    avatarColor: "blue",
    type: "booking",
  },
  {
    id: "4",
    clientId: "c4",
    name: "Laura Brown",
    action: "made payment of",
    detail: "£180.00",
    time: "2 hours ago",
    avatarColor: "green",
    type: "payment",
  },
  {
    id: "5",
    clientId: "c5",
    name: "Sophie Anderson",
    action: "was added as a new client",
    time: "3 hours ago",
    avatarColor: "orange",
    type: "new_client",
  },
  {
    id: "6",
    clientId: "c6",
    name: "Michael Davis",
    action: "completed",
    detail: "Laser Hair Removal",
    time: "4 hours ago",
    avatarColor: "red",
    type: "treatment",
  },
  {
    id: "7",
    clientId: "c7",
    name: "David Wilson",
    action: "signed consent form for",
    detail: "Chemical Peel",
    time: "5 hours ago",
    avatarColor: "teal",
    type: "consent",
  },
];

const ClientActivity = () => {
  const navigate = useNavigate();

  const handleViewAll = () => {
    navigate("/aesthetics/clients");
  };

  const handleActivityClick = (clientId: string) => {
    navigate(`/aesthetics/clients/${clientId}`);
  };

  const getActionColor = (type: Activity["type"]) => {
    switch (type) {
      case "consent":
        return "text-blue-600";
      case "treatment":
        return "text-green-600";
      case "booking":
        return "text-purple-600";
      case "payment":
        return "text-emerald-600";
      case "new_client":
        return "text-orange-600";
      default:
        return "text-muted-foreground";
    }
  };

  return (
    <div className="bg-card rounded-2xl p-6 shadow-md">
      <div className="flex items-center justify-between mb-3 border-b border-gray-200 pb-3">
        <h2 className="text-lg font-semibold text-foreground">Client Activity</h2>
        <button 
          onClick={handleViewAll}
          className="text-[#704AAF] font-medium hover:underline flex items-center gap-1"
        >
          View all <ChevronRight className="w-4 h-4" />
        </button>
      </div>
      <div className="space-y-4">
        {activities.map((activity) => (
          <div 
            key={activity.id} 
            className="flex items-center gap-3 cursor-pointer hover:bg-gray-50 rounded-lg p-2 -mx-2 transition-colors"
            onClick={() => handleActivityClick(activity.clientId)}
          >
            <Avatar name={activity.name} color={activity.avatarColor} size="sm" />
            <div className="flex-1 min-w-0">
              <p className="text-sm text-foreground">
                <span className="font-semibold">{activity.name}</span>{" "}
                <span className="text-muted-foreground">{activity.action}</span>
                {activity.detail && (
                  <span className={`font-medium ${getActionColor(activity.type)}`}> {activity.detail}</span>
                )}
              </p>
            </div>
            <span className="text-sm text-gray-500 whitespace-nowrap flex items-center gap-1">
              {activity.time} <ChevronRight className="w-4 h-4" />
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientActivity;
